import { useFetch } from '../useFetch/useFetch.svelte.js';
import { isPromise } from '@vpap_svelte/internal';
/**
 *
 * @param resource The URL you want to fetch
 * @param fetchStateOptions Options for how you want to handle or transform fetch results
 * @param requestOptions
 * @returns
 */
export function useFetchState(resource, requestOptions = {}, fetchStateOptions = {}) {
    let status = $state('idle');
    let data = $state(fetchStateOptions.initialData ?? null);
    let error = $state(null);
    let isInitial = $state(true);
    let fetchManager = useFetch(resource, requestOptions, {
        onFetch: () => {
            status = 'loading';
            if (fetchStateOptions.keepDataWhileFetching !== true &&
                (isInitial === false || data === null)) {
                data = null;
            }
        },
        onSuccess: (res) => {
            const transformedResponse = fetchStateOptions.transformSuccess
                ? fetchStateOptions.transformSuccess(res)
                : res;
            if (isPromise(transformedResponse)) {
                // typescript can't figure out that this is guaranteed to be a promise
                const pr = transformedResponse;
                pr.then((prResponse) => {
                    status = 'success';
                    error = null;
                    data = prResponse;
                });
            }
            else {
                status = 'success';
                error = null;
                data = transformedResponse;
            }
        },
        onError: (e) => {
            status = 'error';
            // even on errors we probably should keep the data because abort errors can happen due to a change in url
            // while fetching
            if (fetchStateOptions.keepDataWhileFetching !== true &&
                (isInitial === false || data === null)) {
                data = null;
            }
            error = fetchStateOptions.transformError ? fetchStateOptions.transformError(e) : e;
        },
        onCompletion: () => {
            isInitial = false;
        },
        immediate: fetchStateOptions.immediate,
    });
    return {
        get status() {
            return status;
        },
        get data() {
            return data;
        },
        get error() {
            return error;
        },
        load() {
            if (fetchManager.isActive) {
                fetchManager.pause();
            }
            fetchManager.run();
        },
        /**
         * Permanently stop the manager from fetching
         */
        stop() {
            fetchManager.stop();
        },
        /**
         * Stop fetching the resource
         */
        pause() {
            fetchManager.pause();
        },
        /**
         * Aborts a request.
         *
         * This allows people to abort requests early, for instance, in order to set a maximum response time
         */
        abort() {
            fetchManager.abort();
        },
    };
}
